const DEVICE_KEY = 'kp_device_id'

export function getDeviceId() {
  let id = ''
  try {
    id = localStorage.getItem(DEVICE_KEY) || ''
  } catch (e) {
    /* ignore */
  }
  if (!id) {
    id = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `web-${Date.now()}-${Math.random().toString(16).slice(2)}`
    try {
      localStorage.setItem(DEVICE_KEY, id)
    } catch (e) {
      /* ignore */
    }
  }
  return id
}

const MOBILE_WIDTH = 768

export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export function isNarrowViewport() {
  return typeof window !== 'undefined' && window.innerWidth <= MOBILE_WIDTH
}

/** 落地页 / 教程页布局：UA 是手机，或视口本身就是手机宽度（含 Chrome 设备模式） */
export function resolveLayoutDevice() {
  return (isMobileDevice() || isNarrowViewport()) ? 'mobile' : 'desktop'
}

export function applyRootFontSize(device) {
  if (typeof document === 'undefined') return
  const layout = device || resolveLayoutDevice()
  const docEl = document.documentElement
  const width = window.innerWidth || 375
  docEl.classList.remove('mobile', 'desktop')
  docEl.classList.add(layout)
  if (document.body) {
    document.body.classList.remove('mobile', 'desktop')
    document.body.classList.add(layout)
  }
  if (layout === 'mobile') {
    docEl.style.fontSize = `${(width / 2) * 0.2}px`
    docEl.style.height = ''
  } else {
    docEl.style.fontSize = `${48 * (width / 1000)}px`
    docEl.style.height = '100%'
  }
}

export function isIOSDevice() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export function getDevicePlatform() {
  return isIOSDevice() ? 'ios' : 'web'
}

export function getDeviceName() {
  const ua = navigator.userAgent || ''
  if (/iPhone/i.test(ua)) return 'iPhone Safari'
  if (/iPad/i.test(ua)) return 'iPad Safari'
  if (/Android/i.test(ua)) return 'Android Browser'
  return ua.slice(0, 64) || 'Web Browser'
}

/** 落地页主按钮用：ios / android */
export function detectMobileOs() {
  const ua = (navigator.userAgent || '').toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) return 'ios'
  return 'android'
}

/** 实际设备系统，用来和用户点的安装包对照 */
export function detectUaPlatform() {
  const ua = navigator.userAgent || ''
  if (/Android/i.test(ua)) return 'android'
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  if (/Macintosh|Mac OS X/i.test(ua)) return 'macos'
  if (/Windows/i.test(ua)) return 'windows'
  return 'other'
}

export function detectClientPlatform() {
  const ua = detectUaPlatform()
  if (ua === 'ios' || ua === 'android' || ua === 'macos' || ua === 'windows') return ua
  return 'windows'
}
